import forage from 'localforage'

export const fTable = forage.createInstance({
  name: 'crms-table',
  storeName: 'rsm',
  driver: [
    forage.INDEXEDDB,
    forage.LOCALSTORAGE
  ]
})

const setTableOptions = ({ currentPage, perPage, sortBy, sortDesc, filter, totalRows }) => {
  return fTable.setItem('area-managers-other-events', {
    currentPage,
    perPage,
    sortBy,
    sortDesc,
    totalRows,
    filter: {
      search: filter.search,
      month: filter.month,
      areaManager: filter.areaManager,
      activity: filter.activity,
      event_date: filter.event_date
    }
  })
}

const getTableOptions = async () => {
  return await fTable.getItem('area-managers-other-events')
}

export {
  setTableOptions,
  getTableOptions
}
